<template>
  <footer class="footer">
    <div class="container">
      <div class="footer__grid">
        <app-logo class="logo" />

        <article>
          <ul>
            <li
              v-for="({ line }, index) in address"
              :key="`address_${index}`"
            >
              {{ translate(line) }}
            </li>

            <li
              v-for="({ line }, index) in phone_number"
              :key="`phone_${index}`"
            >
              {{ translate(line) }}
            </li>

            <li
              v-for="({ url, text }, index) in emails"
              :key="`email_${index}`"
            >
              <a
                class="link__color--black"
                :href="url"
                target="_blank"
              >
                {{ text }}
              </a>
            </li>
          </ul>
        </article>

        <article class="navigation">
          <ul>
            <li
              v-for="({ link }, index) in navigation"
              :key="`navigation_${index}`"
            >
              <app-link
                :link="link"
                class="navigation__link link__color--black"
              />
            </li>
          </ul>
        </article>

        <app-social-networks
          :facebook="['fab', 'facebook-f']"
          :linkedin="['fab', 'linkedin-in']"
        />
      </div>
    </div>
  </footer>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from '@/vendors/i18n'

import AppLogo from '&/atoms/AppLogo'
import AppLink from '&/atoms/AppLink'
import AppSocialNetworks from '&/molecules/AppSocialNetworks'

const { section } = defineProps({
  section: { type: Object, required: true }
})

const { translate } = useI18n()

const { address = [], navigation = [], phone_number = [], email = [] } = section.attributes

const emails = computed(() => {
  return email.map(({ line }) => {
    return {
      text: translate(line).replace(/ /g, ''),
      url: 'mailto:' + translate(line).replace(/ /g, '')
    }
  })
})
</script>

<style lang="scss" scoped>
.footer {
  padding: 60px 16px;
  background-color: #FBFBFB;
  font-size: rem(14px);

  .container {
    padding: 0;
  }

  &__grid {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    gap: $margin--base * 2;
    justify-content: space-between;

    @include mq(md) {
      grid-template-columns: repeat(4, fit-content(100px));
    }
  }
}

:deep() {
  .logo {
    max-width: 100px;

    @include mq(md) {
      max-width: 160px;
    }
  }

  .networks {
    &__ul {
      display: flex;
      flex-wrap: nowrap !important;
      justify-content: center;
      gap: 48px;

      @include mq(sm) {
        display: grid;
        grid-template-columns: repeat(5, 1fr);
        gap: 24px;
      }
    }

    &__a {
      color: $black;
      display: flex;
      justify-content: center;
      align-items: center;
      transition: all .3s ease-out;
      width: 45px;
      height: 45px;
      border: 1px solid $black;
      border-radius: 50%;

      &:hover {
        color: $white;
        background-color: $black;
      }
    }
  }
}
</style>
